import { Injectable, inject } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ErrorHandlerService } from './error-handler.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private errorHandler = inject(ErrorHandlerService);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(() => {
        // Success - could log successful requests if needed
      }),
      catchError((error: HttpErrorResponse) => {
        // Handle HTTP errors and show user notifications
        this.handleHttpError(error, req);
        return throwError(() => error);
      })
    );
  }

  private handleHttpError(
    error: HttpErrorResponse,
    req: HttpRequest<any>
  ): void {
    // Skip error tracking endpoint to avoid infinite loops
    if (req.url.includes('/errors/v1/report')) {
      return;
    }

    // Extract meaningful context from the request
    const context = {
      endpoint: req.url,
      method: req.method,
      component: this.extractComponentFromUrl(req.url),
      action: this.extractActionFromUrl(req.url, req.method),
    };

    // Handle the error through our error handler service
    this.errorHandler.handleHttpError(error, context);
  }

  private extractComponentFromUrl(url: string): string {
    // Extract component name from URL patterns
    const urlParts = url.split('/').filter((part) => part.length > 0);

    if (urlParts.includes('auth')) {
      if (urlParts.includes('check-email')) return 'EmailValidation';
      if (urlParts.includes('check-username')) return 'UsernameValidation';
      return 'Authentication';
    }

    if (urlParts.includes('products')) return 'Products';
    if (urlParts.includes('categories')) return 'Categories';
    if (urlParts.includes('suppliers')) return 'Suppliers';
    if (urlParts.includes('sales')) return 'Sales';
    if (urlParts.includes('reports')) return 'Reports';

    return 'Application';
  }

  private extractActionFromUrl(url: string, method: string): string {
    const urlParts = url.split('/').filter((part) => part.length > 0);

    if (method === 'GET') {
      if (urlParts.includes('check-email')) return 'Verificar Email';
      if (urlParts.includes('check-username'))
        return 'Verificar Nome de Usuário';
      return 'Consultar dados';
    }

    if (method === 'POST') return 'Criar registro';
    if (method === 'PUT') return 'Atualizar registro';
    if (method === 'DELETE') return 'Excluir registro';

    return 'Operação';
  }
}
